import { useModelService } from 'services/model/model.service';
import { customKpi, InfoDrawerKpiEntry, measureKpi } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { toFeesAndCostsRateMeasure } from 'components/profitability/profitabilityMeasures';

function useHubInfoContentKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [
    netSlsGmvVal,
    cm1Rate,
    cm2Rate,
    netSlsFeeRate,
    netSlsLogCostRate,
    netSlsMkpFeeVal,
    slsPayFeeVal,
    netSlsFeeVal,
    slsShpCostVal,
    slsHdlCostVal,
    retShpCostVal,
    retHdlCostVal,
    netSlsLogCostVal,
  ] = getMeasures([
    'netSlsGmvValExtExpOD',
    'cm1RateExtExpOD',
    'cm2RateExtExpOD',
    'netSlsFeeRateExtExpOD',
    'netSlsLogCostRateExtExpOD',
    'netSlsMkpFeeValExtExpOD',
    'slsPayFeeValOD',
    'netSlsFeeValExtExpOD',
    'slsShpCstValOD',
    'slsHdlCstValOD',
    'retShpCstValExtExpOD',
    'retHdlCstValExtExpOD',
    'netSlsLogCostValExtExpOD',
  ]);

  const feesAndCostsRate = toFeesAndCostsRateMeasure(netSlsFeeRate, netSlsLogCostRate);

  return [
    measureKpi(netSlsGmvVal),
    customKpi('cm1RateExt', {
      titleId: 'profitability.info.cm1RateExt.title',
      descriptionId: 'profitability.info.cm1RateExt.description',
      measure: cm1Rate,
    }),
    customKpi('netSlsFeeValExt_netSlsLogCostValExt', {
      titleId: 'profitability.info.netSlsFeeValExt_netSlsLogCostValExt.title',
      descriptionId: 'profitability.info.netSlsFeeValExt_netSlsLogCostValExt.description',
      measure: feesAndCostsRate,
    }),
    customKpi('cm2RateExt', {
      titleId: 'profitability.info.cm2RateExt.title',
      descriptionId: 'profitability.info.cm2RateExt.description',
      measure: cm2Rate,
    }),
    measureKpi(netSlsMkpFeeVal),
    measureKpi(slsPayFeeVal),
    measureKpi(netSlsFeeVal),
    customKpi('slsShpCostValExt', {
      titleId: 'profitability.info.slsShpCostValExt.title',
      descriptionId: 'profitability.info.slsShpCostValExt.description',
      measure: slsShpCostVal,
    }),
    customKpi('slsHdlCostValExt', {
      titleId: 'profitability.info.slsHdlCostValExt.title',
      descriptionId: 'profitability.info.slsHdlCostValExt.description',
      measure: slsHdlCostVal,
    }),
    measureKpi(retShpCostVal),
    measureKpi(retHdlCostVal),
    measureKpi(netSlsLogCostVal),
  ];
}

export function ProfitabilityHubInfoContent() {
  const kpis = useHubInfoContentKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="profitability.info.whyUseful.hub.description"
      showOrderBasedNote
    />
  );
}
